export enum Text {
  Decline = 'Decline All Offers',
  CashToYou = 'Cash to You',
}
